
import React from 'react';

interface CharacterCounterProps {
  current: number;
  max: number;
}

const CharacterCounter = ({ current, max }: CharacterCounterProps) => {
  return (
    <span className="text-xs text-redflags-gray">
      {current}/{max}
    </span>
  );
};

export default CharacterCounter;
